import account from "../../services/account";
export default {

  props: {
    moveMaisIdParceiroSelecionado: undefined,
  },

  data() {
    return {
      mostrarModal: true,
      segundaPeriodo1: undefined,
      segundaPeriodo2: undefined,
      tercaPeriodo1: undefined,
      tercaPeriodo2: undefined,
      quartaPeriodo1: undefined,
      quartaPeriodo2: undefined,
      quintaPeriodo1: undefined,
      quintaPeriodo2: undefined,
      sextaPeriodo1: undefined,
      sextaPeriodo2: undefined,
      sabadoPeriodo1: undefined,
      sabadoPeriodo2: undefined,
      domingoPeriodo1: undefined,
      domingoPeriodo2: undefined,
      feriadoPeriodo1: undefined,
      feriadoPeriodo2: undefined
    };
  },
  mounted(){
    this.getHorariosParceiros(this.moveMaisIdParceiroSelecionado);
  },


  computed: {

  },
  methods: {
    getHorariosParceiros(moveMaisId){
        account.getHorariosParceiros(moveMaisId).then(res =>{
          if(res.status.code === 0){
            this.segundaPeriodo1 = res.listaHorarios.segundaPeriodo1;
            this.segundaPeriodo2 = res.listaHorarios.segundaPeriodo2;
            this.tercaPeriodo1 = res.listaHorarios.tercaPeriodo1;
            this.tercaPeriodo2 = res.listaHorarios.tercaPeriodo2;
            this.quartaPeriodo1 = res.listaHorarios.quartaPeriodo1;
            this.quartaPeriodo2 = res.listaHorarios.quartaPeriodo2;
            this.quintaPeriodo1 = res.listaHorarios.quintaPeriodo1;
            this.quintaPeriodo2 = res.listaHorarios.quintaPeriodo2;
            this.sextaPeriodo1 = res.listaHorarios.sextaPeriodo1;
            this.sextaPeriodo2 = res.listaHorarios.sextaPeriodo2;
            this.sabadoPeriodo1 = res.listaHorarios.sabadoPeriodo1;
            this.sabadoPeriodo2 = res.listaHorarios.sabadoPeriodo2;
            this.domingoPeriodo1 = res.listaHorarios.domingoPeriodo1;
            this.domingoPeriodo2 = res.listaHorarios.domingoPeriodo2;
            this.feriadoPeriodo1 = res.listaHorarios.feriadoPeriodo1;
            this.feriadoPeriodo2 = res.listaHorarios.feriadoPeriodo2;
          }
        }).catch(error =>{
          console.log(error, "erro do catch");
        })
    },

    fecharModal () {
      this.$emit("fecharModal", 1);
    }


  },
};



// WEBPACK FOOTER //
// ./src/components/partner-information/partner-information-modal.js